"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleSearchProvider = exports.GoogleCloudSearchContext = void 0;
var head_1 = __importDefault(require("next/head"));
var react_1 = __importStar(require("react"));
var use_google_search_1 = require("../hooks/use-google-search");
exports.GoogleCloudSearchContext = (0, react_1.createContext)({
    gapiClientId: '',
    googleSearchApplicationId: '',
    googleSearchDataSourceId: '',
    isGapiLoaded: false,
});
function GoogleSearchProvider(props) {
    var children = props.children, gapiClientId = props.gapiClientId, googleSearchApplicationId = props.googleSearchApplicationId, googleSearchDataSourceId = props.googleSearchDataSourceId;
    var _a = (0, react_1.useState)(false), loaded = _a[0], setLoaded = _a[1];
    (0, react_1.useEffect)(function () {
        window.onGoogleCloudSearchApiLoad = function () {
            var onApiLoad = function () {
                (0, use_google_search_1.getGapi)().config.update('cloudsearch.config/apiVersion', 'v1');
                setLoaded(true);
            };
            (0, use_google_search_1.getGapi)().load('client:auth2:cloudsearch-widget', { callback: onApiLoad });
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(head_1.default, { key: "google-api-key" },
            react_1.default.createElement("script", { src: use_google_search_1.googleSearchConfig.googleApiScriptSourceUrl, async: true, defer: true })),
        react_1.default.createElement(exports.GoogleCloudSearchContext.Provider, { value: { gapiClientId: gapiClientId, isGapiLoaded: loaded, googleSearchApplicationId: googleSearchApplicationId, googleSearchDataSourceId: googleSearchDataSourceId } }, children)));
}
exports.GoogleSearchProvider = GoogleSearchProvider;
